import React, { useMemo, useRef } from "react";
import QRCode from "react-qr-code";
import "./certification.css";

const CertificationQRCode = ({ certificationId, size = 200, includeUrl = true }) => {
  const containerRef = useRef(null);

  const qrValue = useMemo(() => {
    if (!certificationId) return "";
    const baseUrl = typeof window !== "undefined" ? window.location.origin : "https://tuodominio.com";
    return includeUrl ? `${baseUrl}/verify/${certificationId}` : certificationId;
  }, [certificationId, includeUrl]);

  const handleDownload = () => {
    const svg = containerRef.current?.querySelector("svg");
    if (!svg) return;

    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svg);
    const svgBlob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
    const url = URL.createObjectURL(svgBlob);

    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const targetSize = 512;
      canvas.width = targetSize;
      canvas.height = targetSize;
      const context = canvas.getContext("2d");
      if (!context) return;

      context.fillStyle = "#ffffff";
      context.fillRect(0, 0, targetSize, targetSize);
      context.drawImage(image, 0, 0, targetSize, targetSize);

      const pngUrl = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = pngUrl;
      link.download = `certification-qr-${certificationId}.png`;
      link.click();
      URL.revokeObjectURL(url);
    };

    image.src = url;
  };

  if (!certificationId) {
    return <div className="cert-empty">QR code unavailable</div>;
  }

  return (
    <div style={{ textAlign: "center" }}>
      <div ref={containerRef} style={{ display: "inline-block", background: "#ffffff", padding: 12, borderRadius: 16 }}>
        <QRCode value={qrValue} size={size} level="H" bgColor="#ffffff" fgColor="#111827" />
      </div>
      <div style={{ marginTop: 10, fontSize: 12, color: "#475569" }}>Scan to verify</div>
      <button
        type="button"
        onClick={handleDownload}
        className="cert-ipfs-button"
        style={{ marginTop: 12, background: "#0ea5e9" }}
      >
        Download QR Code
      </button>
    </div>
  );
};

export default CertificationQRCode;
